<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/media-pricing/details' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.EditMedia") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.MediaTitle')"
              >
                <vs-input
                  v-model="mediaTitle"
                  :label="$t('setup.label.MediaTitle')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.MediaCatagory") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.MediaCatagory')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="mediaCategory"
                    :options="networkEleData.mediaCategeorydata"
                    :reduce="(catageoryId) => catageoryId.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">
                      {{ option.mCodeValue }}
                    </template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ContentProvider") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ContentProvider')"
                >
                  <v-select
                    label="mCodeValue"
                    v-model="contentProviderValue"
                    :options="networkEleData.contentProviderData"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(contentProvider) => contentProvider.id"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Share')"
              >
                <vs-input
                  v-model="cpShareValue"
                  :label="$t('setup.label.Share')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.MediaLocation')"
              >
                <vs-input
                  v-model="location"
                  :label="$t('setup.label.MediaLocation')"
                  class="w-full mb-5 font-semibold starlabel"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.Status") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.Status')"
                >
                  <v-select
                    label="value"
                    v-model="status"
                    :options="networkEleData.mediaStatus"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(status) => status.value"
                  >
                    <template v-slot:option="option">{{
                      option.value
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="saveMedia">{{
            $t("setup.label.Save")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import vSelect from "vue-select";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      networkEleData: {},
      mediaTitle: "",
      catageoryId: "",
      contentProvider: "",
      mediaCategory: "",
      contentProviderValue: "",
      cpShareValue: "",
      location: "",
      dateFormat: "dd MMMM yyyy",
      formatType: "",
      languageId: "",
      locale: "en",
      mediaAssetLocations: [],
      contentProviderData: "",
      mediaTypeCheck: "",
      mediaassetAttributes: [],
      status: "",
      releaseDate: moment().format("DD MMMM YYYY"),
      mediaId: "",
      mediatype: null,
      ratingCount: 0,
      systemById: {},
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {},
  methods: {
    async getMediaTemplateData() {
      try {
        const response = await this.$store.dispatch(
          "mediaDetails/getMediaElementTemplateAction"
        );
        this.networkEleData = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editMediaDataById() {
      try {
        const response = await this.$store.dispatch(
          "mediaDetails/editMediaElementDataAction",
          this.$route.params.id
        );
        this.systemById = response.data;
        this.location = this.systemById.mediaLocationData[0].location;
        this.cpShareValue = this.systemById.mediaAssetData.cpShareValue;
        this.mediaTitle = this.systemById.mediaAssetData.mediaTitle;
        this.status = this.systemById.mediaAssetData.status;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async saveMedia() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        id: this.$route.params.id,
        data: {
          mediaTitle: this.mediaTitle,
          location: this.location,
          catageoryId: this.mediaCategory,
          contentProvider: this.contentProviderValue,
          cpShareValue: this.cpShareValue,
          status: this.status,
          releaseDate: this.releaseDate,
          locale: this.locale,
          dateFormat: this.dateFormat,
          mediatype: this.mediatype,
          ratingCount: this.ratingCount,
          mediaTypeCheck: this.mediaTypeCheck,
        },
      };
      await this.$store.dispatch(
        "mediaDetails/updateMediaElementAction",
        payload
      );
      this.$router.push("/setup/media-pricing/details");
    },
    cancel() {
      this.$router.push("/setup/media-pricing/details");
    },
  },

  mounted() {
    this.getMediaTemplateData();
    this.editMediaDataById();
  },
};
</script>
